/* eslint react/prop-types: 0 */
import { useState } from 'react';
import { Handle, Input, Label, LabelText, Toggle } from './styles';

export const SwitchStateless = ({
  checked,
  disabled,
  name,
  size,
  noText,
  checkedText = 'Active',
  uncheckedText = 'Inactive',
  labelStyles,
  toggleStyles,
  onChange,
  labelPlacement = 'bottom',
  dataTestId = 'switch-input',
  ...otherProps
}) => {
  return (
    <Label
      size={size}
      disabled={disabled}
      labelPlacement={labelPlacement}
      /* FIXME: react/jsx-props-no-spreading */
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...otherProps}
      data-testid={dataTestId}
    >
      <Input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        name={name}
      />
      <Toggle size={size} css={toggleStyles}>
        <Handle size={size} />
      </Toggle>
      <LabelText css={labelStyles} size={size}>
        {!noText && (checked ? checkedText : uncheckedText)}
      </LabelText>
    </Label>
  );
};

export const Switch = (props) => {
  const { checked, onChange, ...otherProps } = props;
  const [internalIsChecked, setInternalIsChecked] = useState(checked);

  if (checked !== internalIsChecked) {
    setInternalIsChecked(checked);
  }

  const handleChange = (evt) => {
    setInternalIsChecked((_isChecked) => !_isChecked);
    if (onChange) {
      onChange(evt);
    }
  };

  /* FIXME: react/jsx-props-no-spreading */
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  return <SwitchStateless checked={internalIsChecked} onChange={handleChange} {...otherProps} />;
};
